import React, {useContext, useMemo, useState} from "react"

import { Table } from "reactstrap"

import { ScenarioContext } from "../../contexts/ScenarioContext"

import CallOutText from "../CallOutText"


const AssessmentFindingsTabContent = () => {
    const {
        checkListItems,
        isChecked,
        scenario
    } = useContext(ScenarioContext)

    const checkedAssessmentSteps = useMemo(
        () => {
            return scenario.calloutLabels.filter(callout => isChecked(callout.id))
        },
        [checkListItems]
    )

    return (
        <Table size="sm" striped={true}>
            <thead>
                <tr>
                    <th>Assessment</th>
                    <th>Finding</th>
                </tr>
            </thead>
            <tbody>
                {checkedAssessmentSteps.map((step) => (
                    <tr key={step.id}>
                        <th>{step.label}</th>
                        <td>
                            <CallOutText
                                step={step}
                                displayAssessmentFindings={true}
                            />
                        </td>
                    </tr>
                )
                )}
            </tbody>
        </Table>
    )

}

export default AssessmentFindingsTabContent